import React, { Component } from "react";
import CustomDataTableSearch from "../../../../partials/content/CustomDataTableSearch";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";
import {
  getOutlets,
  getAllOutlets,
} from "../../../../services/sales/outletService";
import withGlobalData from "../../common/withGlobalData";
class SearchOutlet extends Component {
  state = { reload: this.props.globalData.reload, outlets: [] };

  componentDidMount() {
    this.getOutlets();
  }

  componentDidUpdate() {
    const { globalData } = this.props;
    const { reload } = this.state;
    if (globalData.reload !== reload) {
      this.getOutlets();
      this.setState({ reload: globalData.reload });
    }
  }

  async getOutlets() {
    const { allOutlets } = this.props;
    let response = {};
    if (allOutlets) {
      response = await getAllOutlets();
    } else {
      response = await getOutlets();
    }

    const { data } = response.data;
    this.setState({ open: false, outlets: data.outlets });
  }

  render() {
    const { outlets } = this.state;
    const { onSelectOutlet } = this.props;
    return (
      <CustomDataTableSearch
        data={outlets}
        onRefreshData={() => {
          this.getOutlets();
        }}
        onSelectedData={(rowData, originalEvent) => {
          onSelectOutlet(rowData);
        }}
        columns={[
          {
            field: "select",
            body: (rowData) => (
              <React.Fragment>
                <button
                  type="button"
                  className="btn btn-label-success btn-sm btn-pill btn-bold"
                  onClick={() => onSelectOutlet(rowData)}
                >
                  Select <i className="fas fa-angle-double-right"></i>
                </button>
              </React.Fragment>
            ),
          },
          {
            header: "Outlet ID",
            field: "ID",
            body: null,
            sortable: true,
          },
          {
            header: "Outlet Name",
            field: "outletName",
            body: (rowData) => (
              <React.Fragment>
                <ResponsiveEllipsis text={rowData.outletName} maxLine="1" />
              </React.Fragment>
            ),
            sortable: true,
          },
          {
            header: "Phone Number",
            field: "addressPhone",
            body: (rowData) => (
              <React.Fragment>
                <ResponsiveEllipsis text={rowData.addressPhone} />
              </React.Fragment>
            ),
            sortable: true,
          },
          {
            header: "City",
            field: "city",
            body: (rowData) => (
              <React.Fragment>
                <ResponsiveEllipsis text={rowData.city} maxLine="1" />
              </React.Fragment>
            ),
            sortable: true,
          },
          {
            header: "Currency",
            field: "currency.currencyCode",
            body: null,
            sortable: true,
          },
        ]}
      />
    );
  }
}

export default withGlobalData(SearchOutlet);
